const tenantApiRelativeUrl = "/tenant";
export {
  tenantApiRelativeUrl
};
//# sourceMappingURL=tenantApiRelativeUrl.js.map
